import axios from "axios";
import queryString from "query-string";
import * as helper from "../helpers";
import * as CONST from "../helpers/Constants";
axios.defaults.headers.common['X-CSRF-Token'] =
  document.querySelector('meta[name="csrf-token"]').content;
  
export const postCprQualityMeasurement = async (req) => {
  try {
    let response = await helper.postReq(CONST.INIT_STATE.appName + "/quality_measurements", req);
    return response;
  } catch (error) {
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export const searchICD10Api = async (query) => {
    try {
      let response = await axios.get(`https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code%2Cname&terms=${ query }`);
      return response;
    } catch(error) {
      return { message: "There was an error processing this request." };
    }
};

export const sendAppointmentInstructionsText = async (cpr_id, established_status) => {
  let response = await axios.post(CONST.INIT_STATE.appName + "/api/task_messages/send_appointment_instructions", {
    cpr_id: cpr_id,
    established_status: established_status
  });

  return response;
};

export const getTextMacros = async (patient_id, cpr_id) => {
  var url = CONST.INIT_STATE.appName + '/api/text_macros?';
  if (patient_id) {
    url += `patient_id=${ patient_id }`;
  }

  if (cpr_id) {
    url += `&cpr_id=${ cpr_id }`;
  }

  const request = queryString.stringifyUrl({
    url: url
  });

  const res = await fetch(request);
  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
};

export const uploadFile = async (id, file) => {
  const form = new FormData();
  form.append("quality_measurement[id]", id);
  form.append("quality_measurement[document]", file);
  const data = await helper.postToResource(`${CONST.INIT_STATE.appName}/quality_measurements/${id}/document`, form);
  return data;
};

export const deleteQualityMeasurement = async (req) => {
  try {
    let response = await helper.deleteResource(CONST.INIT_STATE.appName + "/quality_measurements", req);
    return response;
  } catch {
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export const postQualityMeasurement = async (req) => {
  try {
    let response;

    if (req instanceof FormData) {
      response = await helper.postToResource(CONST.INIT_STATE.appName + "/quality_measurements", req);
    } else {
      response = await helper.postReq(CONST.INIT_STATE.appName + "/quality_measurements", req);
    }

    return response;
  } catch (error) {
    console.log(error);
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export const updateQualityMeasurement = async (req) => {
  try {
    let response = await helper.updateToResource(CONST.INIT_STATE.appName + "/quality_measurements", req);
    return response;
  } catch (error) {
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export const postPatientConditions = async (req) => {
  try {
    let response = await axios.post(CONST.INIT_STATE.appName + "/patient_info/health_conditions", req);
    return response;
  } catch (error) {
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export const deleteTaskMessage = async (req) => {
  try {
    const request = queryString.stringifyUrl({
      url: CONST.INIT_STATE.appName + "/api/task_messages",
      query: { id: req.id }
    });
    const res = await axios.delete(request);
    return { message: "Success", success: res };
  } catch (error) {
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export const updateTaskMessage = async (req) => {
  try {
    const res = await axios.put(CONST.INIT_STATE.appName + "/api/task_messages", { task_message: req });
    return { message: "Success", success: res };
  } catch (error) {
    return { message: "There was an error processing this request.", error: error.message };
  }
};

export async function getTasksByView(params) {
  let queryParams = {
    page: params.page,
    view: params.view,
  };

  const request = queryString.stringifyUrl({
    url: CONST.INIT_STATE.appName + "/api/tasks",
    query: { ...queryParams },
  });
  const res = await fetch(request);
  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
}

export const searchTasks = async (params) => {
  const request = queryString.stringifyUrl({
    url: CONST.INIT_STATE.appName + "/api/tasks/search",
    query: {
      status: params.status,
      query: params.query,
      page: params.page,
      task_type: params.task_type,
      tag_list: params.tags,
      tag_filter_type: params.tagFilterType,
      appointment_request_status: params.appointment_request_status
    },
  });
  const res = await fetch(request);
  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
};

export const cancelFaxSpecialistReferral = async (specialist_referral_id) => {

  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/specialist_referrals/cancel_fax", {
    specialist_referral: {
      id: specialist_referral_id
    }
  });
  const data = await response;
  return data;
};

export const regenerateSpecialistReferralPdf = async (specialist_referral_id) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/specialist_referrals/regenerate_pdf", {
    specialist_referral: {
      id: specialist_referral_id
    }
  });
  const data = await response;
  return data;
};

export const faxSpecialistReferral = async (specialist_referral_id) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/specialist_referrals/fax", {
    specialist_referral: {
      id: specialist_referral_id
    }
  });
  const data = await response;
  return data;
};

export const deleteSpecialistReferral = async (specialist_referral_id) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/specialist_referrals/delete", {
    specialist_referral: {
      id: specialist_referral_id
    }
  });
  const data = await response;
  return data;
};

export const searchSpecialists = async (
  query,
  patientUid,
  specialistType,
  searchType,
  specialistId,
  specialistGroupId
) => {
  const request = queryString.stringifyUrl({
    url: CONST.INIT_STATE.appName + "/api/specialists",
    query: {
      uid: patientUid,
      query: query,
      specialist_type: specialistType,
      search_type: searchType,
      specialist_id: specialistId,
      specialist_group_id: specialistGroupId,
    },
  });
  const res = await fetch(request);
  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
};

export async function getTasksByPage(params) {
  const request = queryString.stringifyUrl({
    url: params.url,
    query: { page: params.page, status: params.status },
  });
  const res = await fetch(request);

  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
}

export async function getFilteredTasks(params) {
  let queryParams = {
    page: params.page,
  };
  params.assigner_support_group_id
    ? (queryParams = {
        ...queryParams,
        assigner_support_group_id: params.assigner_support_group_id,
      })
    : params.assignee_support_group_id
    ? (queryParams = {
        ...queryParams,
        assignee_support_group_id: Array.isArray(params.assignee_support_group_id)
          ? params.assignee_support_group_id.join()
          : params.assignee_support_group_id,
      })
    : queryParams;

  if (params.appointment_request_status) {
    queryParams = { ...queryParams, appointment_request_status: params.appointment_request_status };
  }

  const request = queryString.stringifyUrl({
    url: params.url,
    query: { ...queryParams },
  });
  const res = await fetch(request);
  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
}

export const getTaskCounts = async () => {
  try {
    return await (
      await axios.get(CONST.INIT_STATE.appName + "/api/task_counts")
    ).data;
  } catch (error) {
    return error;
  }
};

export const getSettings = async () => {
  let settings = await helper.fetchResource(CONST.INIT_STATE.appName + "/api/tasks/settings");
  return settings;
};

export const getPhoneCalls = async () => {
  let data = await helper.fetchResource("call_center/api/calls/ongoing");
  return data;
};

export const saveCallCenterSettings = async (afterhoursEnabled, weekendsEnabled) => {
  let response = await helper.postToResource("call_center/api/call_center_settings", {
    'call_center_setting': {
      'afterhours_enabled': afterhoursEnabled,
      'weekends_enabled': weekendsEnabled
    }}
  );

  if (response) {
    return response;
  }
}

export const getSpecialists = async (params) => {
  let specialists = await helper.fetchResource(CONST.INIT_STATE.appName + "/api/tasks/specialists?specialist_practice_id=" + params['specialist_practice_id']);
  return specialists;
};

export const getTasksByParams = async (params) => {
  let tasks = await helper.fetchResource(CONST.INIT_STATE.appName + "/api/tasks?" + `${params}`);
  const data = await tasks;
  return data.tasks;
};

export const getTasks = async () => {
  let tasks = await helper.fetchResource(CONST.INIT_STATE.appName + "/api/tasks");
  const data = await tasks;
  return data.tasks;
};

export const getTasksByType = async (type) => {
  let tasks = await helper.fetchResource(CONST.INIT_STATE.appName + "/api/tasks?task_type=" + `${type}`);
  const data = await tasks;
  return data.tasks;
};

export const getTaskById = async (id) => {
  let task = await helper.fetchResource(CONST.INIT_STATE.appName + "/api/task/" + `${id}`);
  const data = await task;
  return data;
};

export const postTask = async (req) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/api/tasks", req);
  const data = await response;
  return data;
};

export const postVisitStatusCheck = async (req) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/cprs/visit_status_check", req);
  const data = await response;
  return data;
};

export const postFormDataTask = async (req) => {
  const formData = new FormData();
  req['task'] && req['task']['document'] && formData.append("task[document]", values.document);
  let keys = Object.keys(req['task']);
  for (var i = 0; i < keys.length; i++) {
    formData.set(`task[${keys[i]}]`, req['task'][keys[i]]);
  }
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/api/tasks", formData);
  const data = await response;
  return data;
};
export const updateTask = async (id, req) => {
  let response = await helper.updateToResource(CONST.INIT_STATE.appName + "/api/task/" + `${id}`, req);
  const data = response;
  return data;
};

export const notifyTask = async (id, req) => {
  let response = await helper.updateToResource(CONST.INIT_STATE.appName + "/api/task/" + `${id}` + "/notify", req);
  const data = response;
  return data;
};

export const closeTask = async (id, req) => {
  let response = await helper.updateToResource(CONST.INIT_STATE.appName + "/api/task/" + `${id}`, req);
  const data = response;
  return data;
};

export const postTaskMessage = async (req) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/api/task_messages", req);
  const data = await response;
  return data;
};

export const notifyPatientOfDocument = async (req) => {
  let response = await helper.postToResource(CONST.INIT_STATE.appName + "/api/notifications", req);
  const data = await response;
  return data;
};

export const getPatientByName = async (req, taskType) => {
  let response = await helper.fetchResource(CONST.INIT_STATE.appName + `/api/patients/search?query=${ req }&task_type=${ taskType }`);
  const data = await response;
  return data;
};
